var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef } from 'react';
import { Icon } from '@gerdau/hefesto';
import './Accordion.styles.scss';
var Accordion = function (_a) {
    var data = _a.data, onExpandedAccordion = _a.onExpandedAccordion;
    var _b = useState(''), activeId = _b[0], setActiveId = _b[1];
    var toggleAccordion = function (id) {
        var currentId = activeId === id ? '' : id;
        setActiveId(currentId);
        onExpandedAccordion && onExpandedAccordion(currentId);
    };
    return (_jsx("div", __assign({ className: "hefesto-accordion" }, { children: _jsx("div", __assign({ className: "hefesto-accordion hefesto-accordion__header", "aria-label": "title__accordion", role: "banner" }, { children: data.map(function (item) { return (_jsx(AccordionItem, { onClick: toggleAccordion, item: item, activeId: activeId }, item.id)); }) })) })));
};
var AccordionItem = function (_a) {
    var _b;
    var item = _a.item, onClick = _a.onClick, activeId = _a.activeId;
    var contentRef = useRef(null);
    var EMappedInputEventCodes;
    (function (EMappedInputEventCodes) {
        EMappedInputEventCodes["ENTER"] = "Enter";
        EMappedInputEventCodes["SPACE"] = "Space";
    })(EMappedInputEventCodes || (EMappedInputEventCodes = {}));
    var handleKeyDown = function (event) {
        if (!Object.values(EMappedInputEventCodes).find(function (code) { return code === event.code; })) {
            return;
        }
        onClick(item.id);
    };
    return (_jsxs("div", __assign({ className: "hefesto-accordion__item" }, { children: [_jsxs("div", __assign({ className: "hefesto-accordion__item__header", onClick: function () { return onClick(item.id); }, onKeyDown: function (event) { return handleKeyDown(event); } }, { children: [_jsx("div", __assign({ className: "hefesto-accordion__title" }, { children: _jsx("h4", { children: item.title }) })), _jsx("div", __assign({ "aria-label": "icon__accordion_".concat(item.id), role: "button", tabIndex: 0, className: "hefesto-accordion__icon--expand ".concat(activeId === item.id
                            ? 'hefesto-accordion__icon--expand--up'
                            : 'hefesto-accordion__icon--expand--down') }, { children: _jsx(Icon, { option: "ChevronDown" }) }))] })), _jsx("div", __assign({ className: "hefesto-accordion__content ".concat(activeId === item.id ? 'opened' : ''), ref: contentRef, style: {
                    height: activeId === item.id ? (_b = contentRef.current) === null || _b === void 0 ? void 0 : _b.scrollHeight : '0px',
                } }, { children: _jsx("span", { children: item.content }) }))] })));
};
export default Accordion;
